const ACCOUNT_TYPE_LABELS = {
  buyer_owner_tenant: "Buyer / Owner / Tenant",
  agent: "Agent",
  builder: "Builder",
  admin: "Admin"
};

export function formatAccountType(accountType) {
  const normalized = String(accountType || "").trim().toLowerCase();
  return ACCOUNT_TYPE_LABELS[normalized] || "Member";
}
